function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".favicon_svg__st0{fill:#750fb7}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "favicon_svg__st0",
  d: "M77.9 1.9c-.4-.2-.9-.3-1.4-.1L19 23.5c-.5.2-.9.6-.9 1.1l-.6 20.9 45.1-17.1c.5-.2 1-.1 1.4.1.3.1.5.3.6.6.1.1.1.3.1.5v8l13.1-4.9c.6-.2.8-.7.8-1.2V2.9c0-.2-.1-.3-.2-.5s-.3-.4-.5-.5zM2.8 82.1c.4.2.9.3 1.4.1l57.5-21.7c.5-.2.9-.6.9-1.1l.6-20.9L18 55.4c-.5.2-1 .1-1.4-.1-.3-.1-.5-.3-.6-.6-.1-.1-.1-.3-.1-.5v-8l-13.1 5c-.6.2-.8.7-.8 1.2V81c0 .2.1.3.2.5.1.3.3.5.6.6z"
});

function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favicon_svg__\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80.5 84.8",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgFavicon;